import { ReactNode, InputHTMLAttributes, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

type TextInputProps = {
  placeholder?: string;
  className?: string;
  iconPosition?: 'left' | 'right';
  icon?: ReactNode;
} & InputHTMLAttributes<HTMLInputElement>;

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(function TextInput(
  {
    placeholder,
    icon: Icon,
    className = '',
    iconPosition = 'left',
    value,
    onChange,
    ...props
  }: TextInputProps,
  ref
) {
  const dynamicValueProp = {
    [onChange ? 'value' : 'defaultValue']: value,
  };
  const input = (
    <input
      ref={ref}
      type="text"
      className="grow"
      placeholder={placeholder}
      onChange={onChange}
      {...props}
      {...dynamicValueProp}
    />
  );
  const [firstChild, secondChild] = iconPosition === 'left' ? [Icon, input] : [input, Icon];
  return (
    <label
      className={twMerge(
        'input input-bordered flex items-center gap-2 rounded-full bg-base-300',
        props.disabled && 'input-disabled',
        className
      )}
    >
      {firstChild}
      {secondChild}
    </label>
  );
});
